import { useIntl } from 'react-intl'
import { useFormContext } from 'react-hook-form'

import { type LegalFormData, LegalFormPresentational } from '../../../../../../../../components/Forms/LegalFormPresentational'
// import { type LegalStepFormValues } from './types/FormsSteps'

type LegalStepFormProps = {
  isSubmitting: boolean
  onCancel: () => void
  onSubmit: (data: LegalFormData) => void
}

export const LegalStepForm = ({
  isSubmitting,
  onCancel,
  onSubmit,
}: LegalStepFormProps) => {
  const methods = useFormContext<LegalStepFormProps>()
  const { formatMessage } = useIntl()

  return (
    <LegalFormPresentational
      isSubmitting={isSubmitting}
      submitButtonText={formatMessage({ id: 'CONTINUE' })}
      onSubmit={onSubmit}
      onCancel={onCancel}
      {...methods}
    />
  )
}
